import { sendTokenToExtension } from "@/helpers/send-to-extension.ts";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { FullScreenCard } from "@/pages/security/components/FullScreenCard.tsx";
import { TwoFactorSetupForm } from "@/pages/security/components/TwoFactorSetupForm.tsx";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { useAuthStore } from "@/stores/employee.store.ts";
import { Stack } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useEffectOnce } from "react-use";

export function TwoFactorSetupPage() {
  const { t } = useTranslation();
  const handleTfaSetupSuccess = (newToken: string) => {
    setToken(newToken);
    sendTokenToExtension(newToken);
    analyticsService.trackEvent(analyticEvents.loggedIn, {
      [analyticProperties.source]: "Web",
    });
    navigate("/");
  };
  const handleTfaSetupSkip = () => {
    navigate("/");
  };
  const navigate = useNavigate();
  const { token } = useParams();
  const { data: employeeMe, isLoading: employeeMeIsLoading } = useEmployeeMe();
  const { setToken } = useAuthStore();

  useTitle(t("core:two_factor_setup"));

  useEffectOnce(() => {
    if (!token) return;

    setToken(token);
    sendTokenToExtension(token);
    analyticsService.trackEvent(analyticEvents.loggedIn, {
      [analyticProperties.source]: "Web",
    });
  });

  return (
    <FullScreenCard>
      <Stack gap={"sm"} className={"w-full sm:max-w-md "}>
        {employeeMe && !employeeMeIsLoading ? (
          <TwoFactorSetupForm
            accessToken={token ?? ""}
            onSuccess={handleTfaSetupSuccess}
            onSkip={handleTfaSetupSkip}
          />
        ) : (
          ""
        )}
      </Stack>
    </FullScreenCard>
  );
}
